import { ajaxSend } from '../../../../api/api';

export function getAudios(): Promise<unknown> {
  return ajaxSend({
    path: '/v1/announcements',
  });
}
